export class AppSettings {
    public static API_USEDCAR_BASEURL = 'https://www.theaa.com/used-cars/displaycars?utm_source=Routeplannner&utm_medium=the_aa&utm_campaign=AACars_Route_Planner_Widget&utm_content=Search_for_your_next_car';
    public static API_SMARTCARE_BASEURL = 'https://www.theaa.com/car-care/book/friday-member?sc=routeplanner&utm_source=routeplanner&utm_medium=banner&utm_campaign=crosssale';
    public static INTERVAL_IN_SECONDS = 1;
}
